import * as yup from "yup"

export const validationSchema = yup.object().shape({
    mr_unit_code: yup.string().label("Unit code").required().test('len', 'Must be exactly 2 characters', val => val.toString().length === 2),
    mr_unit_name: yup.string().label("Unit name").required().max(100, "Must be 100 characters or less"),
    description: yup.string().label("Description").optional()
  })